/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GeoElectricMeasure } from "./GeoElectricMeasure";
import {
  GeoElectricMeasureFromJSON,
  GeoElectricMeasureFromJSONTyped,
  GeoElectricMeasureToJSON,
  GeoElectricMeasureToJSONTyped,
} from "./GeoElectricMeasure";

/**
 *
 * @export
 * @interface ApiFrdGeoelectricmeasuresList200Response
 */
export interface ApiFrdGeoelectricmeasuresList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiFrdGeoelectricmeasuresList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiFrdGeoelectricmeasuresList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiFrdGeoelectricmeasuresList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GeoElectricMeasure>}
   * @memberof ApiFrdGeoelectricmeasuresList200Response
   */
  results: Array<GeoElectricMeasure>;
}

/**
 * Check if a given object implements the ApiFrdGeoelectricmeasuresList200Response interface.
 */
export function instanceOfApiFrdGeoelectricmeasuresList200Response(
  value: object
): value is ApiFrdGeoelectricmeasuresList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiFrdGeoelectricmeasuresList200ResponseFromJSON(
  json: any
): ApiFrdGeoelectricmeasuresList200Response {
  return ApiFrdGeoelectricmeasuresList200ResponseFromJSONTyped(json, false);
}

export function ApiFrdGeoelectricmeasuresList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiFrdGeoelectricmeasuresList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GeoElectricMeasureFromJSON),
  };
}

export function ApiFrdGeoelectricmeasuresList200ResponseToJSON(
  json: any
): ApiFrdGeoelectricmeasuresList200Response {
  return ApiFrdGeoelectricmeasuresList200ResponseToJSONTyped(json, false);
}

export function ApiFrdGeoelectricmeasuresList200ResponseToJSONTyped(
  value?: ApiFrdGeoelectricmeasuresList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GeoElectricMeasureToJSON),
  };
}
